import { render, staticRenderFns } from "./CreateEntity.vue?vue&type=template&id=0ff62c97&scoped=true&"
import script from "./CreateEntity.vue?vue&type=script&lang=js&"
export * from "./CreateEntity.vue?vue&type=script&lang=js&"
import style0 from "./CreateEntity.vue?vue&type=style&index=0&id=0ff62c97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff62c97",
  null
  
)

export default component.exports